import SpriteSymbol from "../../../node_modules/.pnpm/registry.npmmirror.com+svg-baker-runtime@1.4.7/node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/.pnpm/registry.npmmirror.com+svg-sprite-loader@6.0.11/node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-r-icon",
  "use": "icon-r-icon-usage",
  "viewBox": "0 0 20 24",
  "content": "<symbol viewBox=\"0 0 20 24\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-r-icon\">\n<g id=\"icon-r-icon_Frame 181\">\n<path id=\"icon-r-icon_Vector 1\" d=\"M6 5.5L13.6179 11.6896C13.8149 11.8496 13.8149 12.1504 13.6179 12.3104L6 18.5\" stroke=\"white\" stroke-width=\"2\" stroke-linecap=\"round\" />\n</g>\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol